import { render } from "./ButtonPublishers.vue?vue&type=template&id=23006f29"
import script from "./ButtonPublishers.vue?vue&type=script&lang=js"
export * from "./ButtonPublishers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__